import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'shards-react';
import VChart from './VChart';

const rangeOptions = [
  { key: 'week', label: '1 Week' },
  { key: 'month', label: '1 Month' },
  { key: 'year', label: '1 Year' },
  { key: 'all', label: 'From Start' },
];

const UsersOverview = ({
  loading,
  onRangeChange,
  range,
  title,
  users,
}) => {
  const { datasets, labels } = useMemo(() => {
    const sortedUsers = [...(users || [])].sort(
      (first, second) => String(first.period).localeCompare(String(second.period)),
    );
    const counts = sortedUsers.map(item => item.count);
    const total = counts.reduce((result, count) => result + count, 0);

    return {
      labels: sortedUsers.map(item => item.period),
      datasets: [
        {
          label: `Users (${total})`,
          data: counts,
          fill: 'start',
        },
      ],
    };
  }, [users]);

  const buttonClass = value => (
    `btn-white mx-1 my-1${range === value ? ' active' : ''}`
  );

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </CardHeader>
      <CardBody className="pt-0">
        <Row className="border-bottom py-2 bg-light">
          <Col sm="12" className="d-flex flex-wrap justify-content-center">
            {rangeOptions.map(option => (
              <Button
                key={option.key}
                size="sm"
                disabled={loading}
                className={buttonClass(option.key)}
                onClick={() => onRangeChange(option.key)}
              >
                {option.label}
              </Button>
            ))}
          </Col>
        </Row>
        {loading && users.length === 0
          ? <div className="text-center text-muted p-4">Loading user data...</div>
          : users.length > 0
          ? <VChart labels={labels} datasets={datasets} type="line" />
          : <div className="text-center text-muted p-4">No user data in this range</div>}
      </CardBody>
    </Card>
  );
};

UsersOverview.propTypes = {
  loading: PropTypes.bool,
  onRangeChange: PropTypes.func,
  range: PropTypes.oneOf(rangeOptions.map(option => option.key)),
  title: PropTypes.string,
  users: PropTypes.array,
};

UsersOverview.defaultProps = {
  loading: false,
  onRangeChange: () => {},
  range: 'month',
  title: 'Users Overview',
  users: [],
};

export default UsersOverview;
